import { css } from '@emotion/react';

export const hoverEffect = css`
  cursor: pointer;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }

  &[disabled] {
    opacity: 0.25;
  }
`;
